import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store.js'
import prismAdminComponent from '@/components/prism_admin'
import { path } from '@amcharts/amcharts4/core.js'


const kyc_listing = () => import('@/components/prism_admin/kyc/listing')
const kyc_upload = () => import('@/components/prism_admin/kyc/upload')

const pan_attempt_list = () => import('@/components/prism_admin/panAttempt/pan_attempt_list')
const pan_details_info = () => import('@/components/prism_admin/adminUsers/pan_details_info')
//-------------------------referal-coupon------------------------------------------------------------------------------
const coupon_listing = () => import('@/components/prism_admin/referalCoupon/coupon_listing')
const coupon_file_upload = () => import('@/components/prism_admin/referalCoupon/coupon_file_upload')
//-------------------------admin-Users------------------------------------------------------------------------------
const subscriptionList = () => import('@/components/prism_admin/subscription/subscription_list')
const subscriptionView = () => import('@/components/prism_admin/subscription/view')
const UserListing = () => import('@/components/prism_admin/adminUsers/user_listing')
const UserView = () => import('@/components/prism_admin/adminUsers/user_view')
const RmPendingListing = () => import('@/components/prism_admin/adminUsers/rm_pending')
const RmPendingOldListing = () => import('@/components/prism_admin/adminUsers/rm_pending_old_leads')
const RmPendingView = () => import('@/components/prism_admin/adminUsers/rm_pending_view')
const NewRegisteration = () => import('@/components/prism_admin/adminUsers/new_registeration')
const NewRegisterationOldLeads = () => import('@/components/prism_admin/adminUsers/new_registeration_old_leads')
const NewRegisterationView = () => import('@/components/prism_admin/adminUsers/new_registeration_view')
const CompleteRegisteration = () => import('@/components/prism_admin/adminUsers/complete_registeration')
const CompleteRegisterationView = () => import('@/components/prism_admin/adminUsers/complete_registeration_view')
const EsignRegisteration = () => import('@/components/prism_admin/adminUsers/esign_registeration')
const EsignRegisterationOldLeads = () => import('@/components/prism_admin/adminUsers/esign_registeration_old_leads')
const EsignRegisterationView = () => import('@/components/prism_admin/adminUsers/esign_registeration_view')
const CategorisationList = () => import('@/components/prism_admin/adminUsers/categorisation_list')
const CategorisationView = () => import('@/components/prism_admin/adminUsers/categorisation_view')
const DematPendingList = () => import('@/components/prism_admin/adminUsers/demat_pending_list')
const DematPendingView = () => import('@/components/prism_admin/adminUsers/demat_pending_view')
const SearchUserList = () => import('@/components/prism_admin/adminUsers/search_user_list')
const SquadiqUserList = () => import('@/components/prism_admin/adminUsers/squadiq_user_list')
const SearchUserView = () => import('@/components/prism_admin/adminUsers/search_user_view')

const HypervergeBackstageUserList = () => import('@/components/prism_admin/adminUsers/hyperverge_backstage_list')
const HypervergeUsers = () => import('@/components/prism_admin/adminUsers/hyperverge_users')


const source_user_listing = () => import('@/components/prism_admin/adminUsers/source_user_listing')
const lead_user_listing = () => import('@/components/prism_admin/adminUsers/lead_user_listing')
const lead_old_user_listing = () => import('@/components/prism_admin/adminUsers/lead_user_listing_old_leads')
//-------------------------Users------------------------------------------------------------------------------
const UserLogin = () => import('@/components/prism_admin/Users/login')
const UserDashboard = () => import('@/components/prism_admin/Users/dashboard')
const UserClientAccess = () => import('@/components/prism_admin/Users/client_access')

const Upload = () => import('@/components/prism_admin/Users/upload')
const UploadClientCode = () => import('@/components/prism_admin/Users/upload_client_code')


const payment_sheet = () => import('@/components/prism_admin/Users/payment_sheet')

const otp_check = () => import('@/components/prism_admin/Users/otp_check')

const ChangePassword = () => import('@/components/prism_admin/Users/change-password')
const create_admin = () => import('@/components/prism_admin/Users/create-admin')

//-------------------------Tickets-----------------------------------------------------------------------------
const TicketSupport = () => import('@/components/prism_admin/Tickets/support')
const TicketView = () => import('@/components/prism_admin/Tickets/view')
//-------------------------Funds-----------------------------------------------------------------------------
const FundsPayin = () => import('@/components/prism_admin/Funds/payin')
const FundsPayout = () => import('@/components/prism_admin/Funds/payout')
const RejectPayout = () => import('@/components/prism_admin/Funds/reject_payout')
//-------------------------stagging-rising------------------------------------------------------------------------------
const StaggingList = () => import('@/components/prism_admin/adminUsers/stagging_list')
const RisingList = () => import('@/components/prism_admin/adminUsers/rising_list')
//-------------------------stagging-rising------------------------------------------------------------------------------
const DebitList = () => import('@/components/prism_admin/adminUsers/debit_list')
const RisingReconcilList = () => import('@/components/prism_admin/adminUsers/rising_reconcilation_list')
//-------------------------CVL-----------------------------------------------------------------------------
const CVLStatus = () => import('@/components/prism_admin/adminUsers/cvl_status')
const CVLData = () => import('@/components/prism_admin/adminUsers/cvl_response')
//-----------------------------knowlodge-base----------------------------------------------------------------------------

const articleList = () => import('@/components/prism_admin/knowledge/article_Listing')
 const CategoryList = () => import('@/components/prism_admin/knowledge/category_listing')

 const CreateArticle = () => import('@/components/prism_admin/knowledge/create_article')

 const CreateCategory = () => import('@/components/prism_admin/knowledge/create_category')

 const EditArticle = () => import('@/components/prism_admin/knowledge/edit_article')

 const EditCategory = () => import('@/components/prism_admin/knowledge/edit_category')

 //-----------------------------nominee data---------------------------------------------------------------------------
const nomineeList = () => import('@/components/prism_admin/Nominee/nominee_list')

 //-----------------------------api key---------------------------------------------------------------------------
const api_key_list = () => import('@/components/prism_admin/api_key/api_key_list')


const graph = () => import('@/components/prism_admin/shared/graph/graphs')

const splitter_tool = () => import('@/components/prism_admin/splitter_tool/splitter_list')
const grossIncomeList = () => import('@/components/prism_admin/grossAnnualIncome/gross_annual_income_list.vue')



var isBPORoutes = store.state.user.route_roles;
let roleRotes = ()=>{
    switch(isBPORoutes){
        
        case "IKF_USER":
            return [
                {
                    path: '/',
                    name: 'Users.UserLogin',
                    component: UserLogin
                },
                {
                    path: '*',
                    name: 'new',
                    redirect: to => {
                        return { path: '/subscriptions'}
                    }
                },
                
            
                {
                    path:'/',
                    component: prismAdminComponent,
                    children:[
                        {
                            path: '/subscriptions',
                            name: 'Subscription.List',
                            component: subscriptionList,
                        },
                        {
                            path: '/subscriptions/view',
                            name: 'Subscription.View',
                            props: true,
                            component: subscriptionView,
                        },
                        
                    ]
                }
            ]
        default:
            
            return [
                //-------------------------Users------------------------------------------------------------------------------
                {
                  path: '/',
                  name: 'Users.UserLogin',
                  component: UserLogin
                },
                {
                    path: '*',
                    name: 'new',
                    redirect: to => {
                        return { path: '/Users/dashboard'}
                    }
                },  
                //----------------------------------------Inner Pages--------------------------------------------------------------------
                {
                    path:'/',
                    component: prismAdminComponent,
                    children:[
                     //----------------------Subscription list-----------------------------------------------
                    {
                        path: '/subscriptions',
                        name: 'Subscription.List',
                        component: subscriptionList,
                    },
                    {
                        path: '/subscriptions/view',
                        name: 'Subscription.View',
                        props: true,
                        component: subscriptionView,
                    },
                    {
                        path: '/kyc-list',
                        name: 'kyc_listing',
                        component: kyc_listing,
                    },
                    {
                        path: '/pan-info',
                        name: 'adminUsers.pan_details_info',
                        component: pan_details_info,
                    },
                    {
                        path: '/kyc-upload',
                        name: 'kyc_upload',
                        component: kyc_upload,
                    },
                    {
                        path: '/pan-list',
                        name: 'panAttempt.pan_attempt_list',
                        component: pan_attempt_list,
                    },
                    {
                        path: '/cvl-status',
                        name: 'adminUsers.cvl_status',
                        component: CVLStatus,
                    },
                    {
                        path: '/cvl-response-status',
                        name: 'adminUsers.cvl_response_status',
                        component: CVLData,
                    },            
                    //-------------------------referal-coupon------------------------------------------------------------------------------
                    {
                        path: '/coupon-list',
                        name: 'referalCoupon.coupon_listing',
                        component: coupon_listing,
                    },
                    {
                        path: '/upload-coupon-list-file',
                        name: 'referalCoupon.coupon_file_upload',
                        component: coupon_file_upload,
                    },
                    //-------------------------admin-Users------------------------------------------------------------------------------
                    {
                        path: '/lead-registeration',
                        name: 'adminUsers.lead_user_listing',
                        component: lead_user_listing,
                    },
                     {
                        path: '/old-lead-registeration',
                        name: 'adminUsers.lead_old_user_listing',
                        component: lead_old_user_listing,
                    },
            
                    {
                        path: '/rising-reconcilation-list',
                        name: 'adminUsers.RisingReconcilList',
                        component: RisingReconcilList,
                    },
                    {
                        path: '/debit-list',
                        name: 'adminUsers.DebitList',
                        component: DebitList,
                    },
                    {
                        path: '/user-listing',
                        name: 'adminUsers.UserListing',
                        component: UserListing,
                    },
                    {
                        path: '/view',
                        name: 'adminUsers.UserView',
                        props: true,
                        component: UserView,
                    },  
                    {
                        path: '/new-registeration',
                        name: 'adminUsers.NewRegisteration',
                        component: NewRegisteration,
                    },
                    {
                        path: '/new-registeration-old-leads',
                        name: 'adminUsers.NewRegisteration-old-leads',
                        component: NewRegisterationOldLeads,
                    },
                    {
                        path: '/source-user-listing',
                        name: 'adminUsers.source_user_listing',
                        component: source_user_listing,
                    },
                    {
                        path: '/reg-view',
                        name: 'adminUsers.NewRegisterationView',
                        props: true,
                        component: NewRegisterationView,
                    },
                        {
                            path: '/esign-registeration',
                            name: 'adminUsers.EsignRegisteration',
                            component: EsignRegisteration,
                        },
                    // Hyperverge Backstage List
                    {
                        path: '/backstage-users',
                        name: 'adminUsers.HypervergeBackstageList',
                        component: HypervergeBackstageUserList,
                    },
                       {
                        path: '/hyperverge-users',
                        name: 'adminUsers.HypervergeUsers',
                        component: HypervergeUsers,
                    },
                    {
                        path: '/esign-view',
                        name: 'adminUsers.EsignRegisterationView',
                        props: true,
                        component: EsignRegisterationView,
                    },
                    {
                        path: '/complete-registeration',
                        name: 'adminUsers.CompleteRegisteration',
                        component: CompleteRegisteration,
                    },
                    {
                        path: '/squadiq-user-list',
                        name: 'adminUsers.SquadiqUserList',
                        component: SquadiqUserList,
                    },
                    {
                        path: '/complete-registeration-view',
                        name: 'adminUsers.CompleteRegisterationView',
                        props: true,
                        component: CompleteRegisterationView,
                    },
                    {
                        path: '/rm-pending-registeration',
                        name: 'adminUsers.RmPendingListing',
                        component: RmPendingListing,
                    },
                     {
                        path: '/rm-pending-registeration-old-leads',
                        name: 'adminUsers.RmPendingoldListing',
                        component: RmPendingOldListing,
                    },
                    {
                        path: '/rm-view',
                        name: 'adminUsers.RmPendingView',
                        props: true,
                        component: RmPendingView,
                    },
                    {
                        path: '/categorisation-list',
                        name: 'adminUsers.CategorisationList',
                        component: CategorisationList,
                    },
                    {
                        path: '/categorisation-detail',
                        name: 'adminUsers.CategorisationView',
                        component: CategorisationView,
                    },
                    {
                        path: '/demat-pending-list',
                        name: 'adminUsers.DematPendingList',
                        component: DematPendingList,
                    },
                    {
                        path: '/demat-pending-detail',
                        name: 'adminUsers.DematPendingView',
                        component: DematPendingView,
                    },
                    {
                        path: '/search-user',
                        name: 'adminUsers.SearchUserList',
                        component: SearchUserList,
                    },
                     {
                        path: '/search-user-view',
                        name: 'adminUsers.SearchUserView',
                        component: SearchUserView,
                    },
                    //-------------------------stagging-rising-list------------------------------------------------------------------------------
                    {
                        path: '/stagging-list',
                        name: 'adminUsers.StaggingList',
                        component: StaggingList,
                    },
                    {
                        path: '/rising-list',
                        name: 'adminUsers.RisingList',
                        component: RisingList,
                    },
                    //-------------------------Users------------------------------------------------------------------------------
                    {
                        path: '/Users/dashboard',
                        name: 'Users.UserDashboard',
                        component: UserDashboard,
                    },
                    {
                        path: '/client-access',
                        name: 'Users.UserClientAccess',
                        component: UserClientAccess,
                    },
            
                    {
                        path: '/upload-file',
                        name: 'Users.Upload',
                        component: Upload,
                    }, 
                    {
                        path: '/upload-client-code',
                        name: 'Users.UploadClientCode',
                        component: UploadClientCode,
                    },  
                    {
                        path: '/otp-check',
                        name: 'Users.otp_check',
                        component: otp_check,
                    },
                    {
                        path: '/payment-sheet',
                        name: 'Users.payment_sheet',
                        component: payment_sheet,
                    },  
                    {
                        path: '/change-password',
                        name: 'Users.ChangePassword',
                        component: ChangePassword,
                    },
                    {
                        path: '/create-admin',
                        name: 'Users.createAdmin',
                        component: create_admin,
                    },
                    //-------------------------Tickets------------------------------------------------------------------------------
                    {
                        path: '/Tickets/support',
                        name: 'Tickets.TicketSupport',
                        component: TicketSupport,
                    },        
                    {
                        path: '/Tickets/view',
                        name: 'Tickets.TicketView',
                        props: true,
                        component: TicketView,
                    },
                    //-------------------------Funds------------------------------------------------------------------------------
                    {
                        path: '/payin',
                        name: 'Funds.FundsPayin',
                        component: FundsPayin,
                    },        
                    {
                        path: '/payout',
                        name: 'Funds.FundsPayout',
                        component: FundsPayout,
                    },
                    {
                        path: '/reject-payout',
                        name: 'Funds.RejectPayout',
                        component: RejectPayout,
                    },
            
                    //-----------------Knowledgebase------------------------------------------------------
            
                    {
                        path: '/articles-list',
                        name: 'knowledge.articleList',
                        component: articleList,
                    },
                     {
                         path: '/category-list',
                         name: 'knowledge.CategoryList',
                         component: CategoryList,
                     },
                     {
                        path: '/create-article',
                        name: 'knowledge.CreateArticle',
                        component: CreateArticle,
                     },
                    {
                         path: '/create-category',
                         name: 'knowledge.CreateCategory',
                         component: CreateCategory,
                     },
                     {
                         path: '/edit-article',
                         name: 'knowledge.EditArticle',
                         component: EditArticle,
                     },
                     {
                         path: '/edit_category',
                         name: 'knowledge.EditCategory',
                         component: EditCategory,
                     },
                    //-----------------------nominee list-----------------------------------------------
                    {
                        path: '/nominee-list',
                        name: 'Nominee.nomineeList',
                        component: nomineeList,
                    },
                    //-----------------------api-key-----------------------------------------------
                    {
                        path: '/api-key-list',
                        name: 'api_key.api_key_list',
                        component: api_key_list,
                    },
                    {
                        path: '/reports',
                        name: 'graph',
                        component: graph,
                    },
                    //-----------------------Splitter tool-----------------------------------------------
                    {
                        path: '/spltter-tool',
                        name: 'splitter',
                        component: splitter_tool,
                    },
                    {
                        path: '/gross-annual-income',
                        name: 'adminUsers.GrossAnnualIncomeList',
                        component: grossIncomeList,
                    }
                  ]
                },    
            ]
    }
    return []
  }
Vue.use(Router)
const router = new Router({
    mode: 'history',
    routes: roleRotes()
})

router.beforeEach((to, from, next) => {
  let userStateVariable = store.state.user
  if(userStateVariable == ''){
    userStateVariable= {}
  }
  //console.log('userStateVariable in router ',userStateVariable)
  if(to.name !== 'Users.UserLogin'  && (userStateVariable == null || Object.keys(userStateVariable).length == 0)) {
    //console.log('1')
        next({ name: 'Users.UserLogin' })
  }else if((to.name !== 'Users.UserLogin' && to.name !== 'adminUsers.SquadiqUserList' && to.name !== 'Users.ChangePassword') && (userStateVariable !== null  && Object.keys(userStateVariable).length > 0 && userStateVariable.roles.includes("SSU"))) {
         //console.log('2',userStateVariable)
        // next()
         next({ name: 'Users.UserLogin' })
   }else if((to.name !== 'Users.UserLogin' || to.name == 'Users.UserLogin') && (userStateVariable !== null  && Object.keys(userStateVariable).length > 0 && userStateVariable.roles.includes("SSU"))) {
         //console.log('3',userStateVariable)
        // next()
        next({ to: '/squadiq-user-list' })
   }else{
    //console.log('4')
        next()
   } 
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js